import React from "react";
import SideBar from "../../common/SideBar";
import NoticeBoardStudent from "./NoticeBoardStudent";
import HeaderBar from "../../common/HeaderBar";

const NoticeBoardStudentPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <NoticeBoardStudent />
      </div>
    </main>
  );
};

export default NoticeBoardStudentPage;

